import { useEffect } from "react"

import { IRemixApi } from '@remixproject/plugin-api'
import { PluginApi } from '@remixproject/plugin-utils'
import { PluginClient } from '@remixproject/plugin'

import { Stack } from "react-bootstrap"

import { useUpdateEnvironment } from "../../hooks/useUpdateEnvironment"
import { createWeb3Modal, defaultConfig, useWeb3Modal, useWeb3ModalAccount } from "@web3modal/ethers/react"
import { WalletConfigFileContents } from "../../utils/types"
import { TESTNET_CHAIN_ID, TESTNET_CONFIG, WALLET_CONNECT_METADATA, WALLET_CONNECT_PROJECT_ID } from "../../utils/constants"

type WalletProps = {
    client: PluginClient<any, Readonly<IRemixApi>> & PluginApi<Readonly<IRemixApi>>
}

const Wallet = ({ client }: WalletProps) => {
    // 4. Create Ethers config
    const ethersConfig = defaultConfig({
        /*Required*/
        metadata: WALLET_CONNECT_METADATA,
    
        /*Optional*/
        enableEIP6963: true, // true by default
        enableInjected: true, // true by default
        enableCoinbase: true, // true by default
        rpcUrl: '...', // used for the Coinbase SDK
        defaultChainId: 1 // used for the Coinbase SDK
    })
    
    // 5. Create a Web3Modal instance
    createWeb3Modal({
        ethersConfig,
        enableOnramp: false,
        chains: [TESTNET_CONFIG],
        allowUnsupportedChain: true,
        defaultChain: TESTNET_CONFIG,
        projectId: WALLET_CONNECT_PROJECT_ID,
        enableAnalytics: false, // Optional - defaults to your Cloud configuration
        allWallets: "HIDE"
    })

    const { open } = useWeb3Modal()
    const { address, chainId, isConnected } = useWeb3ModalAccount()
    const { handleUpdateEnvironment }  = useUpdateEnvironment()
    
    useEffect(() => {
        client.onload(async () => {
            if (address === undefined) return

            await loadWallet(address)
        })
    }, [address])

    useEffect(() => {
        if (!isConnected || chainId === TESTNET_CHAIN_ID) return

        open({ view: 'Networks' })
    }, [isConnected])

    const loadWallet = async (addr: string) => {
        try {
            const rootDirectoryContents = await client.fileManager.readdir('')

            if (!Object.keys(rootDirectoryContents).includes('coti_wallet_config.json')) {
                await client.fileManager.writeFile('coti_wallet_config.json', JSON.stringify({}, null, "\t"))
            }

            const fileContents: WalletConfigFileContents = JSON.parse(await client.fileManager.getFile('coti_wallet_config.json'))

            let publicKeyFound = false
            let userKey = undefined

            for (const entry of Object.values(fileContents)) {
                if (entry.public_key === addr) {
                    publicKeyFound = true

                    if (entry.user_key) {
                        userKey = entry.user_key
                    }

                    break
                }
            }

            handleUpdateEnvironment(addr, '', userKey)

            if (publicKeyFound) return

            fileContents[Object.keys(fileContents).length] = { type: "BROWSER_WALLET", network: "TESTNET", public_key: addr }

            await client.fileManager.writeFile('coti_wallet_config.json', JSON.stringify(fileContents, null, "\t"))
        } catch (err) {
            // handle case where file does not exist or content is in unexpected format
        }
    }

    return (
        <>
            <Stack>
                <w3m-button />
            </Stack>
        </>
    )
}

export default Wallet